import type { iconComponents } from '../../components/Core/IconImports';
import type { SecretFilePresetType } from '../../interfaces/FileSecret';
import { resolveSecretFilePreset } from './fileSecretPresets';

export type SecretPresetIconName = keyof typeof iconComponents;

/**
 * Same Lucide names as MainButtonMenu / FilesContextMenu secret submenu.
 * Used as center overlay on react-file-icon; color: `text-gray-dark`.
 */
export const SECRET_PRESET_ICON_NAMES: Record<SecretFilePresetType, SecretPresetIconName> = {
  credentials: 'KeyRoundIcon',
  card: 'CreditCardIcon',
  identity: 'FileUserIcon',
  ssh_key: 'KeyIcon',
  custom: 'FileSlidersIcon',
};

/** Center mark when list row has no preset (parent "+ New → Password or secret"). */
export const SECRET_FILE_FALLBACK_ICON_NAME: SecretPresetIconName = 'FileKeyIcon';

/**
 * Lucide center mark for a `.fgsecret` classic file icon.
 * - Known/unknown preset → submenu icon (`resolveSecretFilePreset`: unknown → custom).
 * - Missing preset → FileKeyIcon (list DTO often omits subtype today).
 */
export function getSecretPresetIconName(
  preset: SecretFilePresetType | string | null | undefined,
): SecretPresetIconName {
  if (preset == null || preset === '') {
    return SECRET_FILE_FALLBACK_ICON_NAME;
  }
  return SECRET_PRESET_ICON_NAMES[resolveSecretFilePreset(preset)];
}
